import PropTypes from "prop-types";
import React, { useState } from "react";

import {
  Row,
  Col,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Button,
} from "reactstrap";
//redux

import { Link, useNavigate } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions

// import images
import company from "../../assets/images/auvenir-logo-dark.svg";

//Import config
import CarouselPage from "../Authentication/CarouselPage";
import LoadingSpinner from "../../shared/Loading";
import { postLoginRequest } from "../../helpers/backend_helper";
import { showLoading } from "react-global-loading";
import { SuccessNotify, ErrorNotify } from "../../shared/Alert";

const LoginPassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [loginerror, setLoginError] = useState(false);
  const history = useNavigate();

  //const { error } = useSelector(state => ({
  //  error: state.Login.error,
  //}))

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: "" || "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      showLoading(true);

      postLoginRequest(values)
        .then((res) => {
          if (res.status === true) {
            showLoading(false);
            history.push("/twostepverification");
          } else {
            showLoading(false);
            setLoginError(res.message);
          }
        })
        .catch((err) => {
          showLoading(false);
          history.push("/twostepverification");
          ErrorNotify("Server error please try again");
        });
    },
  });

  return (
    <React.Fragment>
      <div className="auth-page">
        <Container fluid className="logoBackground">
          <Row className="g-0">
            <Col lg={4}></Col>
            <Col lg={4}>
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column shadow-lg p-3 mb-5 bg-white rounded">
                    <div className="mb-4 mb-md-5 text-center">
                      <img src={company} alt="" width="310" />
                    </div>

                    <div className="auth-content">
                      <div className="text-center">
                        <h5 className="mb-0">Enter your Password</h5>
                      </div>
                      <Form
                        className="custom-form mt-4 pt-2"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        {loginerror ? (
                          <Alert color="danger">{loginerror}</Alert>
                        ) : null}

                        <div className="mb-3">
                          <Label className="form-label">Password</Label>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type="password"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="row mb-4">
                          <div className="col">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="remember-check"
                                disabled
                              />
                              <label
                                className="form-check-label"
                                htmlFor="remember-check"
                              >
                                Remember me
                              </label>
                            </div>

                            <div className="mt-3 d-flex justify-content-end">
                              <Col lg={9}></Col>
                              <Col lg={3} className="d-grid">
                                <Button
                                  color="primary"
                                  disabled={loading}
                                  type="submit"
                                >
                                  Next
                                </Button>
                              </Col>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </div>

                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        {new Date().getFullYear()} &copy; Streamworks Tech
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={4}></Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LoginPassword;

LoginPassword.propTypes = {
  history: PropTypes.object,
};
